export const getConversationIdFromPath = (pathname: string): string | null => {
  const match = /^\/messages\/([^/]+)$/.exec(pathname);
  return match && match[1] !== 'sent' ? match[1] : null;
};

export const getConversationHref = (conversationId: string, currentSearch: string): string => {
  const messageFilter = new URLSearchParams(currentSearch).get('messageFilter');
  const search = messageFilter ? `?${new URLSearchParams({ messageFilter }).toString()}` : '';
  return `/messages/${conversationId}${search}`;
};
